export default __webpack_public_path__ + "static/media/SG-DarkBlue-0004.fb24c909.png";